<template>
  <div class="c-config-content">
    <h4 class="c-config-content__title">{{ $t('inviteCoworker') }}</h4>
    <div>
      <div class="form-inline c-form-invite">
        <form-input class="form-group mr-md-2 flex-column" :label="$t('coworkerEmail')" type="email"
                    :model="inviteModel" attribute="email" :errors="formErrors"
                    :placeholder="$t('coworkerEmailPlaceholder')"></form-input>
        <form-select :options="roles" :model="inviteModel" attribute="role" :label="$t('role')"
                     :errors="formErrors" class="form-group mr-md-2 flex-column"></form-select>
        <user-group-select-form :label="$t('group')" :model="inviteModel" attribute="group"
                           class="form-group mr-md-2 flex-column" :errors="formErrors"></user-group-select-form>
        <div class="form-group mr-md-2 c-form-invite__btn">
          <button :disabled="saveLoading" class="btn btn-primary" type="submit" @click="invite(inviteModel)">
            {{ $t('invite') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import crud from '../../../mixins/CRUD';
import UserGroupSelectForm from "../../../components/UserGroupSelectForm";

export default {
  mixins: [crud],
  components: {UserGroupSelectForm},
  props: ['roles'],
  data: function () {
    return {
      inviteModel: {
        role: 'agent',
        group: null
      },
      formErrors: [],
    }
  },
  methods: {
    invite: function (inviteModel) {
      this.$service({url: 'user/invite', method: 'post', data: inviteModel}).then(response => {
        if (response.data) {
          this.inviteModel = {};
          this.$swal({
            text: this.$t('inviteSent'),
            icon: 'success'
          });
          this.$bus.$emit('reloadUsers');
        } else {
          this.$swal({
            text: this.$t('inviteSentFailed'),
            icon: 'error'
          });
        }
      }).catch(error => {
        if (error.response.data.msg) {
          this.$swal({
            text: error.response.data.msg,
            icon: 'error'
          });
          this.showForm = false;
        } else {
          this.formErrors = error.response.data;
        }
      });
    }
  }
}
</script>